import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { DailyAttendanceDto } from '../../../../api-service/clients';
import { formatDate } from '../../../../utilities';

export interface AttendanceDataGridProps {
  rows: DailyAttendanceDto[];
}

const columns: GridColDef[] = [
  { field: 'attendanceDate', headerName: 'Dato', flex: 1, valueFormatter: ({ value }) => formatDate(value) },
  { field: 'offeredLessons', headerName: 'Tilbudte lektioner', flex: 1, type: 'number' },
  { field: 'absentLessons', headerName: 'Fraværslektioner', flex: 1, type: 'number' },
  { field: 'absenceReason', headerName: 'Fraværsårsag', flex: 1.5 },
];

export function AttendanceDataGrid({ rows }: AttendanceDataGridProps) {
  const gridRows = rows.map((row, index) => ({
    id: index,
    ...row,
  }));

  return <DataGridPro rows={gridRows} columns={columns} autoHeight hideFooter disableColumnMenu density="compact" />;
}
